import { useDispatch } from "react-redux";
import { useI18N } from "@src/language/language-context";
import { updateShowOtaInstallationCompleteModal } from "@src/reducers/your-reducer";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import {
  OTA_OBJECT_TYPE,
  ProcessTypes,
} from "@src/cloud-connect/ota-update/constants";

export const useOtaInstallationCompleteModal = (
  activeInstallationData: ActiveInstallationProcessPayload,
) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const isBackupInstallation =
    activeInstallationData?.firmware?.type === OTA_OBJECT_TYPE.FIRMWARE_BACKUP;

  const isCreateBackup = activeInstallationData?.type === ProcessTypes.BACKUP;

  const descriptionTemplate = isCreateBackup
    ? i18n("modules.otaInstallationCompleteModal.descriptionCreateBackup")
    : isBackupInstallation
    ? i18n("modules.otaInstallationCompleteModal.descriptionBackup")
    : i18n("modules.otaInstallationCompleteModal.descriptionFirmware");

  const operationId = isBackupInstallation
    ? activeInstallationData?.update_details?.sftp_backup_operation_id
    : activeInstallationData?.update_details?.sftp_push_operation_id;
  const installationIdText = operationId
    ? i18n(
        "modules.otaInstallationCompleteModal.installationIdTemplate",
      ).replace("{ID}", String(operationId))
    : "";

  const firmwareName = activeInstallationData?.firmware?.filename || "";

  const description = descriptionTemplate
    .replace("{itemName}", firmwareName)
    .replace("{installationId}", installationIdText);

  const itemNameMarker = "__ITEM_NAME__";
  const descriptionTemplateWithMarker = descriptionTemplate.replace(
    "{itemName}",
    itemNameMarker,
  );
  const [descriptionPrefixRaw, descriptionSuffixRaw = ""] =
    descriptionTemplateWithMarker.split(itemNameMarker);

  const texts = {
    title: isCreateBackup
      ? i18n("modules.otaInstallationCompleteModal.titleCreateBackup")
      : isBackupInstallation
      ? i18n("modules.otaInstallationCompleteModal.titleBackup")
      : i18n("modules.otaInstallationCompleteModal.titleFirmware"),
    subtitle: isCreateBackup
      ? i18n("modules.otaInstallationCompleteModal.subtitleCreateBackup")
      : i18n("modules.otaInstallationCompleteModal.subtitle"),
    description,
    descriptionHasItemName: descriptionTemplate.includes("{itemName}"),
    descriptionPrefix: descriptionPrefixRaw.replace(
      "{installationId}",
      installationIdText,
    ),
    descriptionSuffix: descriptionSuffixRaw.replace(
      "{installationId}",
      installationIdText,
    ),
    firmwareName,
    completedStatus: i18n(
      "modules.otaInstallationCompleteModal.completedStatus",
    ),
    overallProgressLabel: i18n(
      "modules.otaInstallationCompleteModal.overallProgressLabel",
    ),
    doneButtonText: i18n("modules.otaInstallationCompleteModal.doneButtonText"),
  };

  const handleCloseModal = () => {
    dispatch(updateShowOtaInstallationCompleteModal(false));
  };

  return {
    texts,
    folders: activeInstallationData?.archive_structure_root_level || [],
    handleCloseModal,
  };
};
